module.exports = __webpack_public_path__ + "static/media/DK.36efc4f9.png";